import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "loader",
  color: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><linearGradient id=\"b\"><stop offset=\"0%\" stop-color=\"currentColor\" stop-opacity=\"0\"></stop><stop offset=\"100%\" stop-color=\"currentColor\" stop-opacity=\".5\"></stop></linearGradient><linearGradient id=\"a\"><stop offset=\"0%\" stop-color=\"currentColor\"></stop><stop offset=\"100%\" stop-color=\"currentColor\" stop-opacity=\".5\"></stop></linearGradient></defs><g stroke-width=\"2\"><path stroke=\"url(#a)\" d=\"M22 12a10 10 0 0 1-20 0\"></path><path stroke=\"url(#b)\" d=\"M2 12a10 10 0 0 1 20 0\"></path></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }